export default __webpack_public_path__ + "static/media/leadrubixlogoone.e3ad15b3.svg";